module.exports = __webpack_public_path__ + "img/Feature.55777786.jpg";